import { Fragment } from 'react'
import { Popover, Transition } from '@headlessui/react'
import clsx from 'clsx'
import { HashLink } from 'react-router-hash-link'
import { Link } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'

import { Container } from '../components/Container'
import { Logo } from '../components/Logo'
import { SignupButton } from './buttons/signup-button'
import { LogoutButton } from './buttons/logout-button'
import { LoginButton } from './buttons/login-button'

function MobileNavIcon({ open }) {
  return (
    <svg className="h-5 w-5 stroke-slate-800" fill="none" strokeWidth={2}>
      <path
        d="M3 6h18M3 12h18M3 18h18"
        className={clsx('transition', open && 'opacity-0')}
      />
      <path
        d="M6 6l12 12M18 6L6 18"
        className={clsx('transition', !open && 'opacity-0')}
      />
    </svg>
  )
}

function MobileNavigation({ authenticated }) {
  return (
    <Popover>
      {({ open }) => (
        <>
          <Popover.Button
            className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/80 shadow-sm ring-1 ring-slate-200"
            aria-label="Toggle navigation"
          >
            <MobileNavIcon open={open} />
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="duration-150 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel className="absolute inset-x-4 top-20 z-50 rounded-2xl bg-white p-5 shadow-2xl ring-1 ring-slate-900/10">
              <div className="flex flex-col gap-4 text-base font-medium text-slate-800">
                <HashLink to="/#features">Features</HashLink>
                <HashLink to="/#pricing">Pricing</HashLink>

                {authenticated ? (
                  <>
                    <Link to="/dashboard">Dashboard</Link>
                    <LogoutButton />
                  </>
                ) : (
                  <>
                    <LoginButton />
                    <SignupButton />
                  </>
                )}
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  )
}

export function Header() {
  const { isAuthenticated } = useAuth0()

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/70 bg-white/80 py-4 backdrop-blur-xl">
      <Container>
        <nav className="flex items-center justify-between">
          <Link to="/" aria-label="Digitalfalse home" className="flex items-center">
            <Logo />
          </Link>



          <div className="hidden items-center gap-4 md:flex">
                        <HashLink to="/#features" className="text-sm font-medium text-slate-700 hover:text-slate-950">
              Features
            </HashLink>
            <HashLink to="/#pricing" className="text-sm font-medium text-slate-700 hover:text-slate-950">
              Pricing
            </HashLink>
          </div>

          <div className="md:hidden">
            <MobileNavigation authenticated={isAuthenticated} />
          </div>
        </nav>
      </Container>
    </header>
  )
}